export default {
  configs: []
}
